import { Box, Container, Grid } from "@mui/material";
import Imposto from "../../../models/imposto";
import { useCallback, useEffect, useState } from "react";
import { useUsuario } from "../../../providers/usuarioProvider";
import Usuario from "../../../models/usuario";
import { getDoc } from "firebase/firestore";
import UsuarioDb from "../../../db/usuarioDb";
import ImpostoDb from "../../../db/impostoDb";
import Isencao from "../timeline/cards/isencao";
import Atualizar from "../home/atualizar";
import Performance from "./cards/performance";
import Oportunidades from "./cards/oportunidades";
import Functions from "../../../callable/functions";
import moment from "moment";
import Patrimonio from "../../../models/analises/patrimonio";
import { map } from "lodash";
import usePromise from "../../util/usePromise";

export default function Inteligencia() {
  const { visualizado } = useUsuario();
  const [usuario, setUsuario] = useState<Usuario>();
  const [imposto, setImposto] = useState<Imposto>();

  const obterPatrimonioPromise = useCallback(
    () =>
      new Functions()
        .obterPatrimonioSnapshot({ data: moment().format() })
        .then((res) => map(res.data, Patrimonio.fromJson)),
    []
  );
  const { data: patrimonio } = usePromise(obterPatrimonioPromise);

  useEffect(() => {
    if (!!visualizado) {
      getDoc(new UsuarioDb().doc({ usuarioId: visualizado })).then((doc) =>
        setUsuario(doc.data())
      );
    }
  }, [visualizado]);

  useEffect(() => {
    if (!!usuario) {
      getDoc(
        new ImpostoDb().doc({
          usuarioId: usuario.id,
          impostoId: usuario.atualizadoAte.format("YYYY-MM"),
        })
      ).then((doc) => setImposto(doc.data()));
    }
  }, [usuario?.id, usuario?.atualizadoAte]);

  return (
    <Container
      maxWidth="lg"
      sx={(theme) => ({
        padding: {
          md: theme.spacing(4, 8),
          xs: theme.spacing(2, 2),
        },
      })}
    >
      <Box display="flex" flexDirection="column">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Atualizar />
          </Grid>
          <Grid item xs={12} md={6} container spacing={2}>
            <Grid item xs={12}>
              <Isencao darf={imposto?.darf} />
            </Grid>
            <Grid item xs={12}>
              <Performance patrimonio={patrimonio} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Oportunidades imposto={imposto} patrimonio={patrimonio} />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
